const feedbackApiReqGenerator = (
  initReq,
  goldenId,
  role,
  updated_by,
  overmerge_predicted,
  overmerge_actual,
  fhirBundle,
  reason,
  overmergeCase,
  incidentId
) => {
  initReq.enterprise_id = goldenId;
  initReq.overmerge_actual = overmerge_actual;
  initReq.actor = role;
  initReq.rec_updated_time = Math.floor(Date.now() / 1000).toString();
  initReq.updated_by = updated_by;
  initReq.overmerge_predicted =
    overmerge_predicted ===
    "AI Prediction- This Focus Identity is an Overmerge case"
      ? 1
      : overmerge_predicted ===
        "AI Prediction- This Focus Identity is not an Overmerge case"
      ? 0
      : 2;
  initReq.fhirBundle = JSON.stringify(fhirBundle);
  initReq.reason = reason;
  initReq.overmergeCase = overmergeCase;
  initReq.incidentId = incidentId;
  return [initReq];
};

export default feedbackApiReqGenerator;
